import React from 'react';
import {
  Box,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { labelTipoArticulo } from '../../../config/tipoArticuloOptions';
import ArticuloInfo360Contenido from './ArticuloInfo360Contenido';
import ProductoInfo360Thumbnail from './components/ProductoInfo360Thumbnail';

interface Props {
  open: boolean;
  codigoArticulo: string | null;
  onClose: () => void;
}

const ProductoInfo360Dialog: React.FC<Props> = ({ open, codigoArticulo, onClose }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Dialog
      open={open && !!codigoArticulo}
      onClose={onClose}
      fullWidth
      maxWidth="lg"
      fullScreen={fullScreen}
      aria-labelledby="articulo-info360-dialog-title"
    >
      <DialogTitle id="articulo-info360-dialog-title" sx={{ pr: 6 }}>
        <Typography variant="h6" component="span" sx={{ fontWeight: 600, color: '#1976d2' }}>
          Info 360
        </Typography>
        <IconButton
          onClick={onClose}
          aria-label="Cerrar"
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {codigoArticulo ? (
          <ArticuloInfo360Contenido
            codigoArticulo={codigoArticulo}
            abrirDocumentosEnNuevaPestana
            accionSecundariaError={{ label: 'Cerrar', onClick: onClose }}
            renderHeader={(producto) => (
              <Stack direction="row" spacing={2} alignItems="flex-start">
                <ProductoInfo360Thumbnail producto={producto} dimension={56} />
                <Box>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {producto.descripcion?.trim() || producto.codigoArticulo}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    #{producto.codigoArticulo}
                    {producto.codBarra ? ` · Cód. barras ${producto.codBarra}` : ''}
                  </Typography>
                  <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ mt: 1 }}>
                    <Chip
                      size="small"
                      label={labelTipoArticulo(producto.tipoArticulo)}
                      variant="outlined"
                    />
                    {producto.idUnidadMedida ? (
                      <Chip size="small" label={`UM: ${producto.idUnidadMedida}`} variant="outlined" />
                    ) : null}
                  </Stack>
                </Box>
              </Stack>
            )}
          />
        ) : null}
      </DialogContent>
    </Dialog>
  );
};

export default ProductoInfo360Dialog;
